/* eslint-disable */
<template>
  <div></div>
</template>

<script>
/* global dataLayer */
import _ from 'lodash';

export default {
  name: 'course-home',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    newBlueScreenRedirect(props) {
      this.$enablePlaypositErrorScreen({
        vertical: true,
        active_color: '#2196F3',
        base_color: '#0d47a1',
        inactive_color: '#757575',
        title: _.has(props, 'title') ? props.title : 'Error',
        subtitle: _.has(props, 'subtitle') ? props.subtitle : 'Sorry, something has gone wrong.',
        code: _.has(props, 'code') ? props.code : '',
        text: _.has(props, 'text') ? props.text : '',
        icon: _.has(props, 'icon') ? props.icon : 'error',
        buttons: _.has(props, 'buttons') ? props.buttons : [],
      });
      dataLayer.errorLog(props);
    },
  },
  async created() {
    this.newBlueScreenRedirect({
      title: '404',
      subtitle: 'That page can\'t be found',
      text: 'Check the URL you entered or try launching your course from your user dash.',
      status: 404,
      location: `/course/${window.location.pathname}`,
    });
  },
};
</script>
